import { useNavigate } from 'react-router-dom'
import { Vars } from '@carrent/ui'

/** Гаджет: Эффективность менеджеров: столбцы с именами. */

export function ManagerEfficiencyWidget({ data }) {
  const navigate = useNavigate()

  if (!data.items.length) {
    return <p className="widget-empty">За период никто не закрывал рейсы</p>
  }

  const max = Math.max(...data.items.map((i) => i.closed), 1)

  return (
    <ul className="ranking">
      {data.items.map((m) => (
        <li key={m.user_id}>
          <button
            type="button"
            className="ranking__row"
            onClick={() => navigate(`/admin/users/${m.user_id}`)}
          >
            <span className="ranking__name">{m.name}</span>
            <span className="ranking__track">
              <Vars
                as="span"
                className="ranking__bar"
                vars={{ '--bar-w': `${(m.closed / max) * 100}%` }}
              />
            </span>
            <span className="ranking__value">
              {m.closed}
              {m.avg_lag_h != null && (
                <span className="ranking__lag" title="Среднее время до подтверждения">
                  {m.avg_lag_h} ч
                </span>
              )}
            </span>
          </button>
        </li>
      ))}
    </ul>
  )
}
